import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_DISTRICT_DEFINITIONS,
  ADD_DISTRICT_DEFINITION,
  UPDATE_DISTRICT_DEFINITION,
  DELETE_DISTRICT_DEFINITION
} from "./actionTypes"

import {

  getDistrictDefinitionSuccess,
  addDistrictDefinitionSuccess,
  updateDistrictDefinitionSuccess,
  deleteDistrictDefinitionSuccess,
  districtError
  
} from "./actions"

//Include Both Helper File with needed methods
import {

addDistrictDefinition,
updateDistrictDefinition,
deleteDistrictDefinition,
getDistrictDefinition

} from "../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* onGetDistrictDefinition() {
  try {
    const response = yield call(getDistrictDefinition)
    yield put(getDistrictDefinitionSuccess(response))
  } catch (error) {
    yield put(districtError(error))
  }
}

function* onAddDistrictDefinition({ payload: record }) {
  try {
    const response = yield call(addDistrictDefinition, record)
    yield put(addDistrictDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(districtError(error))
  }
}

function* onUpdateDistrictDefinition({ payload: record }) {
  try {
    const response = yield call(updateDistrictDefinition, record)
    yield put(updateDistrictDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(districtError(error))
  }
}

function* onDeleteDistrictDefinition({ payload: guid }) {
  try {
    const response = yield call(deleteDistrictDefinition, guid)
    yield put(deleteDistrictDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(districtError(error))
  }
}


function* districtDefinitionManagementSaga() {

    yield takeEvery(GET_DISTRICT_DEFINITIONS,onGetDistrictDefinition)
    yield takeEvery(ADD_DISTRICT_DEFINITION,onAddDistrictDefinition)
    yield takeEvery(UPDATE_DISTRICT_DEFINITION,onUpdateDistrictDefinition)
    yield takeEvery(DELETE_DISTRICT_DEFINITION,onDeleteDistrictDefinition)
}

export default districtDefinitionManagementSaga
